import React, { useRef } from 'react'
import PlainHero from '../component/PlainHero/PlainHero'
import ContactForm from '../component/ContactForm/ContactForm'
import Header from '../component/Header/Header'
import Footer from '../component/Footer/Footer'
import FaqSection from '../component/FaqSection/FaqSection'
import { Helmet } from 'react-helmet'

function Contact() {

  const faqRef = useRef(null);
  const warrantyRef = useRef(null);

  const scrollToFaqSection = () => {
    faqRef.current?.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'start' 
    });
  };
  const scrollToWarrantySection = () => {
    warrantyRef.current?.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'start' 
    });
  };

  const faqData = [
    {
        title:"What are architectural surface films?",
        content:"<p class='body-paragraph'>The <b>3M DI-NOC</b> Architectural Finishes Films are high-performance finishes applied over existing surfaces to transform their appearance, without demolition. They replicate materials like wood, stone, and metal with incredible realism.</p>"
    },
    {
        title:"Where can these films be applied?",
        content:`<p class='body-paragraph'>
        They can be installed on:</p>
          <ul>
            <li><p class='body-paragraph mb-0'>Walls </p></li>
            <li><p class='body-paragraph mb-0'>Doors </p></li>
            <li><p class='body-paragraph mb-0'>Elevators </p></li>
            <li><p class='body-paragraph mb-0'>Millwork & cabinetry </p></li>
            <li><p class='body-paragraph mb-0'>Columns and panels </p></li>
          </ul>
          <p class='body-paragraph'>Perfect for offices, retail, hotels, healthcare, and multi-residential spaces.</p>
        </p>`
    },
  ]
  
  const faqData1 = [
  {
      title:"Do I need to remove existing finishes before installation?",
      content:`<p class='body-paragraph'>Not always. One of the biggest advantages is that films can often be applied directly over existing surfaces.
      <br>
      However, the condition (chips, dents, texture) will determine the level of preparation required.
      </p>`
  },
  {
      title:"How long does installation take?",
      content:"<p class='body-paragraph'>Most projects are completed in <b>a fraction of the time</b> compared to traditional renovations, often within days, not weeks.</p>"
  },
  {
      title:"Will my business need to shut down during installation?",
      content:"<p class='body-paragraph'>In most cases, no. We can work in phases, after hours, or during low-traffic periods to minimize disruption.</p>"
  },
]

const performanceData = [
  {
    title: "How durable are architectural films?",
    content: `<p class='body-paragraph'>They are designed for high-traffic environments, offering resistance to:</p>
              <ul>
                <li><p class='body-paragraph mb-0'>Scratches</p></li>
                <li><p class='body-paragraph mb-0'>Moisture</p></li>
                <li><p class='body-paragraph mb-0'>UV exposure</p></li>
              </ul>`
  },
  {
    title: "Are they easy to maintain?",
    content: "<p class='body-paragraph'><b>Yes.</b> Regular cleaning with non-abrasive products keeps surfaces looking new.</p>"
  },
  {
    title: "Can damaged areas be repaired?",
    content: "<p class='body-paragraph'>Yes. Unlike traditional materials, damaged sections can often be repaired or replaced without redoing the entire surface.</p>"
  }
];

const costValueData = [
  {
    title: "Is this more affordable than traditional renovation?",
    content: `<p class='body-paragraph'><b>Yes, significantly.</b> You save on:</p>
              <ul>
                <li><p class='body-paragraph mb-0'>Demolition</p></li>
                <li><p class='body-paragraph mb-0'>Material costs</p></li>
                <li><p class='body-paragraph mb-0'>Labor</p></li>
                <li><p class='body-paragraph mb-0'>Downtime</p></li>
              </ul>`
  },
  {
    title: "Do you offer consultations?",
    content: "<p class='body-paragraph'>Yes. We typically start with a site visit to assess surfaces and recommend the best approach.</p>"
  }
];

const designCustomData = [
  {
    title: "What design options are available?",
    content: `<p class='body-paragraph'>Hundreds of finishes including:</p>
              <ul>
                <li><p class='body-paragraph mb-0'>Wood grains</p></li>
                <li><p class='body-paragraph mb-0'>Marble & stone</p></li>
                <li><p class='body-paragraph mb-0'>Metallics</p></li>
                <li><p class='body-paragraph mb-0'>Solid colors</p></li>
              </ul>`
  },
  {
    title: "Can you help with design selection?",
    content: "<p class='body-paragraph'>Absolutely. Through <b>MES Décors</b>, we provide design guidance to ensure the finish aligns with your brand and space.</p>"
  }
];
  return (
    <div>
      <Helmet>
          <title> 
          Contact Halton Surface Systems | Request a Quote
          </title>
          <meta 
          name='description' 
          content="Request a quote or sample from Halton Surface Systems — upholstery fabric, 3M Di-NOC & wall panels for healthcare & commercial projects in Burlington, Ontario." 
          />
          <link rel="canonical" href="https://www.haltonsurfacesystems.com/contact" />

        </Helmet>
        <Header  
            fontDark={true}
        />

        <ContactForm
          scrollToWarrantySection={scrollToWarrantySection}
          scrollToFaqSection={scrollToFaqSection}
        />


   <div className='container' ref={faqRef}>
        <div className='pt-5'>
          <h3 className='body-heading text-center'>FAQs</h3>
        </div>
        <FaqSection
          heading="General Questions"
          faqData={faqData}
        />
        <FaqSection
          heading="Installation & Process"
          faqData={faqData1}
        />

        <FaqSection
      heading="Performance & Durability"
      faqData={performanceData}
    />
    <FaqSection
      heading="Cost & Value"
      faqData={costValueData}
    />
    <FaqSection
      heading="Design & Customization"
      faqData={designCustomData}
    />
    </div>

   <div className='container py-5' ref={warrantyRef}>

    <h3 className='body-heading text-center'>Warranty & Trust</h3>

<div className='row mt-4'>
 <div className='col-lg-6 mb-4'>
        <div className="shadow p-4 rounded bg-white h-100">
            <h3 className='content-heading'>Our Installation Warranty</h3>
            <p className='body-paragraph'>At Halton Surface Systems, we stand behind the quality of our workmanship.</p>
            
            <div className="mb-5">
                <h4 className='fw-bold text-uppercase h6'>One Year Installation Warranty</h4>
                <p className='body-paragraph'>We guarantee that all installations are free from defects related to workmanship.</p>
                <p className='body-paragraph mb-1'>This includes:</p>
                <ul className='list-unstyled body-paragraph'>
                    <li>• Peeling due to improper installation</li>
                    <li>• Bubbling or lifting</li>
                    <li>• Adhesion issues under normal conditions</li>
                </ul>
            </div>
        </div>
    </div>

    {/* Section 2 */}
    <div className='col-lg-6 mb-4'>
        <div className="shadow p-4 rounded bg-white h-100">
            <h3 className='content-heading'>Manufacturer Warranty</h3>
            <p className='body-paragraph'>Our materials, including 3M DI-NOC architectural finishes, are backed by manufacturer warranties.</p>
            
            <div className="mb-5">
                <h4 className='fw-bold text-uppercase h6'>Up to 10–15 Years (depending on application)</h4>
                <p className='body-paragraph mb-1'>Coverage may include:</p>
                <ul className='list-unstyled body-paragraph'>
                    <li>• Fading</li>
                    <li>• Cracking</li>
                    <li>• Delamination</li>
                </ul>
                <p className='body-paragraph text-muted fst-italic'>(Warranty duration varies by product and environment. details provided per project.)</p>
            </div>
        </div>
    </div>
</div>
    {/* Last 3 in a row */}
    <div className="row pt-4 border-top">
        <div className="col-md-4 mb-4">
            <h4 className='fw-bold text-uppercase h5'>Warranty Conditions</h4>
            <p className='body-paragraph  mb-1'>To maintain warranty coverage:</p>
            <ul className='list-unstyled body-paragraph '>
                <li>• Surfaces must be properly maintained</li>
                <li>• No misuse or intentional damage</li>
                <li>• Installation must be done by certified professionals (like HSS)</li>
            </ul>
        </div>

        <div className="col-md-4 mb-4">
            <h4 className='fw-bold text-uppercase h5'>What’s Not Covered</h4>
            <ul className='list-unstyled body-paragraph '>
                <li>• Physical damage (impact, cuts, vandalism)</li>
                <li>• Improper cleaning methods</li>
                <li>• Pre-existing surface defects not addressed prior to installation</li>
            </ul>
        </div>

        <div className="col-md-4 mb-4">
            <h4 className='fw-bold text-uppercase h5'>Support & Service</h4>
            <p className='body-paragraph  mb-1'>If an issue arises, our team will:</p>
            <ul className='list-unstyled body-paragraph '>
                <li>• Inspect the area</li>
                <li>• Determine the cause</li>
                <li>• Provide repair or replacement solutions quickly</li>
            </ul>
        </div>
    </div>

</div>

        <Footer/>
    </div>
  )
}

export default Contact